var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.27,
    y: 90.38,
    width: 141.53,
    height: 237.6,
    rx: 7.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.54,274.8a19.66,19.66,0,0,0-2.77.24s-5.5-.25-9,8.5-1,18.5-5.5,25.5-8,7.75-36.75,8-38.75,5.25-50.25-9.75-7-22.5-16.5-26c-4.69-1.73-7.73-1.14-10,.59-3,3.49-5.39,6.76-4.53,11.91,1.5,9,10.25,23.75,28.25,35.25s39.25,15.75,63,13.25,33.5-12.75,41.75-24.75,9.25-26.25,8-33.75A12.53,12.53,0,0,0,257.54,274.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.33,188s9.9,4.86,14.76,6.16,16.06,1.31,16.62,5.42-1.68,26.52-3,33.8-1.49,18.12-.75,20.92,3,7.28.38,11.77-4.11,10.27-10.09,9.33-7.47-5.23-7.47-5.23l-36.41,4.49s-2.81-14.76-6-27.83-9.71-31.75-9.15-40.71,12.14-14.57,20.17-17.18S211.33,188,211.33,188Z",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.39,234.14s1.12,13.26,2.24,19.24a81.68,81.68,0,0,1,1.31,10.45s4.48-.93,5.41,2.62a11.21,11.21,0,0,1-3.92,11.39c-3.74,2.8-8.78,4.67-12.51,3.55s-5-10.46-5-16.25,0-13.26-1.68-17.55S171.37,229.28,182.39,234.14Z",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,202.77s6,17.74,8.6,17.18,3.92-19.61,3.92-19.61A16.06,16.06,0,0,1,197,202.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.64,185.77s6.66,12,11.77,16.06c4.76,3.79,12.14,5.42,15.68,1.12s4.49-14,4.3-20.17-4.67-10.27-9.71-15.31-12.7-11.58-17.74-8.22S180,181.85,181.64,185.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.13,280.28a12.43,12.43,0,0,1-2.1,1c-1.79.65-5.52,2.67-7,8.47-2,7.75,8,28.75,9.25,38a105.21,105.21,0,0,0,2.25,12.75s3.75,1,10,2,8.5-2.25,8.5-2.25,2.75-23-1.25-37-4.75-20.5-10-22.5C226.09,279.39,221.79,279.31,220.13,280.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.27,337.54s17.25,4.25,28,0c0,0-6.25,29-10.75,41.75s-4.25,18.75-5,25.75-5,19.25-10.5,21.25-6-7.5-2.25-16.75,5.25-20.5,3.75-34S219.27,337.54,219.27,337.54Z",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207,282s-9-3.75-15.5,2.25-4.5,19-4,21.5,1,5.25,1,5.25l1.25,31.75,17.5.25s3.25-25.25,5.75-36.25S215.52,287.29,207,282Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.52,337.79s3.25,24,6.5,35,6.5,24,6.5,37,10.5,18.5,13.25,16,.5-15-1.75-21.5-5.25-22.75-4.25-31.25S212,339,212,339,194.52,340,185.52,337.79Z",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.24,135.11S400.91,89.4,347.18,82.63,256,108.87,216.41,125.8c-20.7,8.86-44.35,5.42-66.33,9.71C79.8,149.23,53.33,235.2,82.6,284.09c25.34,42.32,70,64.33,137.87,69.41S336,364.5,396.85,323,453.62,195.21,425.24,135.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.24,135.11S400.91,89.4,347.18,82.63,256,108.87,216.41,125.8c-20.7,8.86-44.35,5.42-66.33,9.71C79.8,149.23,53.33,235.2,82.6,284.09c25.34,42.32,70,64.33,137.87,69.41S336,364.5,396.85,323,453.62,195.21,425.24,135.11Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-70"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.4,
    cy: 385.14,
    rx: 78.71,
    ry: 22.21,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.4,
    cy: 385.14,
    rx: 78.71,
    ry: 22.21,
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,384.18c0,3.73-33.94,6.76-75.81,6.76s-75.81-3-75.81-6.76,33.94-6.76,75.81-6.76S412.62,380.44,412.62,384.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,384.18c0,3.73-33.94,6.76-75.81,6.76s-75.81-3-75.81-6.76,33.94-6.76,75.81-6.76S412.62,380.44,412.62,384.18Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.09,
    y: 81.68,
    width: 159.88,
    height: 255,
    rx: 11.18,
    transform: "translate(670.07 418.36) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.27,
    y: 90.38,
    width: 141.53,
    height: 237.6,
    rx: 7.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.27,241.72v78.87a7.39,7.39,0,0,0,7.39,7.39H398.41a7.39,7.39,0,0,0,7.39-7.39V241.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,241.72v78.87a7.39,7.39,0,0,0,7.39,7.39H398.41a7.39,7.39,0,0,0,7.39-7.39V241.72Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.54,
    cy: 152.68,
    r: 34.5,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.54,
    cy: 152.68,
    r: 34.5,
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.36,162.5a5.22,5.22,0,0,0-5,3.83H326.69a5.24,5.24,0,0,0-3.74-3.67V161.1h23.44a1.38,1.38,0,0,0,1.37-1.13l2.76-14.52a1.39,1.39,0,0,0-1.37-1.65H323v-6.53a1.38,1.38,0,0,0-1-1.32l-7.58-2.42a1.4,1.4,0,1,0-.85,2.66l6.62,2.1v24.43a5.22,5.22,0,1,0,6.52,6.4h13.64a5.22,5.22,0,1,0,5-6.62Zm-16-15.91h4v11.72h-4Zm6.8,0h4v11.72h-4Zm9.11,11.73h-2.32V146.59h4.55Zm-18.7-11.73v11.72H323V146.59Zm-4.88,23.57a2.44,2.44,0,1,1,2.44-2.44A2.44,2.44,0,0,1,321.66,170.16Zm23.7,0a2.44,2.44,0,1,1,2.44-2.44A2.44,2.44,0,0,1,345.36,170.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.79,
    cy: 142.48,
    r: 10.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "347.08 141.31 351 146.8 358.06 137.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.04,
    y: 205.68,
    width: 76.5,
    height: 24,
    rx: 3,
    style: {
      fill: "#BA68C8"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.45,215.93a.94.94,0,0,1-.24-.64v-4.16c0-.16,0-.31,0-.42a2.33,2.33,0,0,1,.08-.36.75.75,0,0,1,.18-.3.85.85,0,0,1,.3-.18,1.33,1.33,0,0,1,.47-.07H318a6,6,0,0,1,.77,0,3.11,3.11,0,0,1,.68.19,1.86,1.86,0,0,1,.54.35,1.56,1.56,0,0,1,.34.58,2.24,2.24,0,0,1,.13.82,1.77,1.77,0,0,1-.64,1.49,2.88,2.88,0,0,1-1.82.51h-1.14v1.5a.94.94,0,0,1-.24.64.76.76,0,0,1-.58.27A.74.74,0,0,1,315.45,215.93Zm2.26-3.14a3.11,3.11,0,0,0,.5,0,.86.86,0,0,0,.35-.16.62.62,0,0,0,.22-.3,1.37,1.37,0,0,0,.07-.49.88.88,0,0,0-.25-.74,1.42,1.42,0,0,0-.81-.19h-1v1.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.55,215.8a1.71,1.71,0,0,1-.45-1.25v-1.84a1.15,1.15,0,0,1,.18-.7.62.62,0,0,1,.55-.24.56.56,0,0,1,.51.24,1.23,1.23,0,0,1,.16.7v1.82a.85.85,0,0,0,.2.6.66.66,0,0,0,.51.21.86.86,0,0,0,.64-.28,1,1,0,0,0,.26-.71v-1.64a1.15,1.15,0,0,1,.18-.7.62.62,0,0,1,.55-.24.56.56,0,0,1,.51.24,1.23,1.23,0,0,1,.16.7v2.72a.84.84,0,0,1-.17.58.7.7,0,0,1-.54.19c-.46,0-.68-.26-.68-.77v-.06a1.46,1.46,0,0,1-.54.67,1.78,1.78,0,0,1-.91.21A1.52,1.52,0,0,1,321.55,215.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326.54,215.26v-2.8a.67.67,0,0,1,.15-.44.57.57,0,0,1,.35-.22,1.14,1.14,0,0,1,.41,0,.6.6,0,0,1,.34.23.64.64,0,0,1,.15.43v.16a1.87,1.87,0,0,1,.15-.32,3,3,0,0,1,.23-.3,1,1,0,0,1,.33-.24.9.9,0,0,1,.4-.09.51.51,0,0,1,.28.07.38.38,0,0,1,.19.16.58.58,0,0,1,.08.22.42.42,0,0,1,0,.25.73.73,0,0,1-.09.22.42.42,0,0,1-.18.17.58.58,0,0,1-.26.06,1.35,1.35,0,0,0-.79.25.83.83,0,0,0-.33.69v1.52a1.17,1.17,0,0,1-.16.69.62.62,0,0,1-.54.22C326.78,216.2,326.54,215.89,326.54,215.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.44,216.11a2.26,2.26,0,0,1-.73-.4,1.94,1.94,0,0,1-.52-.72,2.54,2.54,0,0,1-.19-1,2.36,2.36,0,0,1,.3-1.19,2.28,2.28,0,0,1,.85-.81,2.46,2.46,0,0,1,1.19-.28,2.92,2.92,0,0,1,.8.11,1.71,1.71,0,0,1,.59.3.57.57,0,0,1,.18.28.52.52,0,0,1,0,.3.82.82,0,0,1-.12.25.36.36,0,0,1-.23.13.59.59,0,0,1-.31-.06,1.5,1.5,0,0,0-.8-.2,1.1,1.1,0,0,0-.76.31,1.17,1.17,0,0,0-.28.85,1.7,1.7,0,0,0,.1.57,1,1,0,0,0,.94.6,1.79,1.79,0,0,0,.83-.21.48.48,0,0,1,.3,0,.31.31,0,0,1,.23.14.84.84,0,0,1,.13.27.56.56,0,0,1,0,.31.59.59,0,0,1-.19.28,1.71,1.71,0,0,1-.62.28,3.33,3.33,0,0,1-.84.1A2.41,2.41,0,0,1,331.44,216.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.75,215.26v-4.51a1.27,1.27,0,0,1,.16-.71.58.58,0,0,1,.52-.23c.48,0,.72.31.72.94v1.68a1.59,1.59,0,0,1,1.58-.76,1.64,1.64,0,0,1,.54.13,1.55,1.55,0,0,1,.46.31,1.53,1.53,0,0,1,.32.51,2,2,0,0,1,.12.71v1.93a1.21,1.21,0,0,1-.16.7.61.61,0,0,1-.54.24c-.46,0-.69-.31-.69-.94v-1.85a.87.87,0,0,0-.2-.6.67.67,0,0,0-.52-.21.82.82,0,0,0-.63.28,1,1,0,0,0-.27.72v1.66a1.21,1.21,0,0,1-.16.7.61.61,0,0,1-.54.24C335,216.2,334.75,215.89,334.75,215.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340.37,215.89a1.26,1.26,0,0,1,.22-2,5.51,5.51,0,0,1,2.18-.3v-.28c0-.45-.24-.68-.72-.68a3.37,3.37,0,0,0-1.26.32.37.37,0,0,1-.42-.08.53.53,0,0,1-.16-.44.43.43,0,0,1,.25-.38,3.45,3.45,0,0,1,.78-.24,4.07,4.07,0,0,1,.9-.1,3,3,0,0,1,.77.09,1.73,1.73,0,0,1,.6.32,1.42,1.42,0,0,1,.41.59,2.73,2.73,0,0,1,.13.91v1.87a.86.86,0,0,1-.12.47.52.52,0,0,1-.31.23.77.77,0,0,1-.37,0,.5.5,0,0,1-.3-.24.79.79,0,0,1-.13-.47v-.07a1.31,1.31,0,0,1-1.42.85A1.5,1.5,0,0,1,340.37,215.89Zm2.05-.71a1,1,0,0,0,.35-.8v-.18h-.43l-.36,0a1.82,1.82,0,0,0-.31.05.9.9,0,0,0-.23.08.41.41,0,0,0-.18.12.77.77,0,0,0-.1.18.58.58,0,0,0,0,.24.56.56,0,0,0,.55.57A1,1,0,0,0,342.42,215.18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M345.12,215.72a.48.48,0,0,1-.16-.22.39.39,0,0,1,0-.26.57.57,0,0,1,.13-.21.34.34,0,0,1,.23-.11.58.58,0,0,1,.3.06l.16.09.24.12a1.54,1.54,0,0,0,.28.09,2.32,2.32,0,0,0,.38.06h.3l.29-.05a.48.48,0,0,0,.23-.13.32.32,0,0,0,.09-.24.28.28,0,0,0-.13-.22,1,1,0,0,0-.39-.17l-.61-.16-.55-.17a3,3,0,0,1-.41-.19,1.08,1.08,0,0,1-.33-.24,1,1,0,0,1-.17-.33,1.31,1.31,0,0,1-.07-.46,1.1,1.1,0,0,1,.55-1,2.4,2.4,0,0,1,1.48-.3,2.73,2.73,0,0,1,.51.07l.37.1.32.14a.51.51,0,0,1,.23.2.38.38,0,0,1,.07.26.68.68,0,0,1-.08.24.34.34,0,0,1-.21.14.67.67,0,0,1-.31,0,3.74,3.74,0,0,0-.89-.22h-.34a.85.85,0,0,0-.32.09.23.23,0,0,0-.15.21.3.3,0,0,0,.12.25,1.3,1.3,0,0,0,.39.14l.6.15a5.47,5.47,0,0,1,.61.2,1.94,1.94,0,0,1,.45.25,1,1,0,0,1,.31.38,1.46,1.46,0,0,1-.15,1.35,1.39,1.39,0,0,1-.7.5,2.61,2.61,0,0,1-1,.13A3.09,3.09,0,0,1,345.12,215.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M350.46,216a1.89,1.89,0,0,1-.84-.77,2.4,2.4,0,0,1-.31-1.26,2.34,2.34,0,0,1,.28-1.16,2.22,2.22,0,0,1,.82-.82,2.41,2.41,0,0,1,1.21-.29,2.29,2.29,0,0,1,.94.17,1.59,1.59,0,0,1,.65.47,2.09,2.09,0,0,1,.35.68,2.66,2.66,0,0,1,.12.82c0,.24-.15.36-.44.36h-2.55a1,1,0,0,0,1.15,1.07,1.53,1.53,0,0,0,.6-.12,1.66,1.66,0,0,0,.5-.3.38.38,0,0,1,.37,0,.52.52,0,0,1,.26.34.36.36,0,0,1-.09.4,2.64,2.64,0,0,1-.29.23l-.36.21a1.91,1.91,0,0,1-.51.17,3.24,3.24,0,0,1-.64.06A2.77,2.77,0,0,1,350.46,216Zm2.05-2.44a1.48,1.48,0,0,0-.22-.78.76.76,0,0,0-.66-.28.8.8,0,0,0-.66.3,1.29,1.29,0,0,0-.27.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M311.33,224.55a2.26,2.26,0,0,1-.73-.4,1.94,1.94,0,0,1-.52-.72,2.54,2.54,0,0,1-.2-1,2.31,2.31,0,0,1,.31-1.18,2.28,2.28,0,0,1,.84-.82,2.53,2.53,0,0,1,1.2-.28,3,3,0,0,1,.8.11,1.81,1.81,0,0,1,.59.3.57.57,0,0,1,.18.28.52.52,0,0,1,0,.3,1.15,1.15,0,0,1-.12.25.36.36,0,0,1-.24.13.58.58,0,0,1-.3-.06,1.51,1.51,0,0,0-.81-.2,1.1,1.1,0,0,0-.75.31,1.13,1.13,0,0,0-.28.85,1.7,1.7,0,0,0,.1.57,1,1,0,0,0,.35.43,1,1,0,0,0,.59.17,1.82,1.82,0,0,0,.83-.21.47.47,0,0,1,.3-.05.31.31,0,0,1,.23.14.84.84,0,0,1,.13.27.56.56,0,0,1,0,.31.59.59,0,0,1-.19.28,1.71,1.71,0,0,1-.62.28,3.33,3.33,0,0,1-.84.1A2.41,2.41,0,0,1,311.33,224.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M315.09,224.07a2.2,2.2,0,0,1-.63-1.65,2.56,2.56,0,0,1,.15-.89,2.26,2.26,0,0,1,.44-.73,2,2,0,0,1,.76-.49,3,3,0,0,1,1.07-.18,2.42,2.42,0,0,1,1.79.62,2.27,2.27,0,0,1,.64,1.67,2.6,2.6,0,0,1-.15.89,2.1,2.1,0,0,1-.45.71,1.92,1.92,0,0,1-.76.49,3,3,0,0,1-1.07.18A2.39,2.39,0,0,1,315.09,224.07Zm2.52-.65a1.7,1.7,0,0,0,.26-1,1.75,1.75,0,0,0-.26-1,.92.92,0,0,0-1.46,0,1.75,1.75,0,0,0-.25,1,1.69,1.69,0,0,0,.25,1,.91.91,0,0,0,1.46,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M320.35,224.4a1.23,1.23,0,0,1-.16-.7v-2.58a1.25,1.25,0,0,1,.16-.69.64.64,0,0,1,.53-.22.65.65,0,0,1,.71.73V221a1.19,1.19,0,0,1,.55-.67,1.83,1.83,0,0,1,.93-.22,2.76,2.76,0,0,1,.44,0,2,2,0,0,1,.39.13,1.11,1.11,0,0,1,.33.29,2,2,0,0,1,.22.49,2.18,2.18,0,0,1,.32-.49,1.4,1.4,0,0,1,.41-.29,2,2,0,0,1,.44-.13,3.38,3.38,0,0,1,.47,0,1.4,1.4,0,0,1,1.06.42,1.67,1.67,0,0,1,.41,1.21v1.93a1.29,1.29,0,0,1-.16.7.61.61,0,0,1-.54.24c-.47,0-.7-.31-.7-.94v-1.85a.85.85,0,0,0-.19-.59.63.63,0,0,0-.5-.22.87.87,0,0,0-.64.26,1,1,0,0,0-.26.71v1.69a1.13,1.13,0,0,1-.17.7.61.61,0,0,1-.54.24c-.46,0-.69-.31-.69-.94V222a1.07,1.07,0,0,0-.18-.67.6.6,0,0,0-.51-.24.91.91,0,0,0-.64.23.8.8,0,0,0-.25.64v1.79c0,.63-.24.94-.73.94A.56.56,0,0,1,320.35,224.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.75,226a1.3,1.3,0,0,1-.15-.7v-4.11a1.36,1.36,0,0,1,.17-.73.61.61,0,0,1,.54-.27.64.64,0,0,1,.5.2.69.69,0,0,1,.18.49V221a1.32,1.32,0,0,1,.58-.63,1.94,1.94,0,0,1,2.25.39,2.48,2.48,0,0,1,.54,1.72,3,3,0,0,1-.16,1,1.78,1.78,0,0,1-.43.71,1.81,1.81,0,0,1-.62.41,1.94,1.94,0,0,1-.76.14,1.71,1.71,0,0,1-.86-.2,1.2,1.2,0,0,1-.54-.55v1.38c0,.63-.24.94-.72.94A.58.58,0,0,1,328.75,226Zm3-2.62a1.73,1.73,0,0,0,.26-1,2.44,2.44,0,0,0,0-.48,1.82,1.82,0,0,0-.16-.43.8.8,0,0,0-.31-.32A.88.88,0,0,0,331,221c-.7,0-1,.46-1,1.37a1.74,1.74,0,0,0,.26,1,.92.92,0,0,0,.75.34A.85.85,0,0,0,331.76,223.4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M334.47,224.4a1.29,1.29,0,0,1-.16-.7v-4.51a1.29,1.29,0,0,1,.16-.7.56.56,0,0,1,.51-.24.63.63,0,0,1,.55.24,1.13,1.13,0,0,1,.18.7v4.51a1.13,1.13,0,0,1-.18.7.63.63,0,0,1-.55.24A.56.56,0,0,1,334.47,224.4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.74,224.44a1.84,1.84,0,0,1-.84-.77,2.41,2.41,0,0,1-.32-1.26,2.35,2.35,0,0,1,.29-1.16,2.09,2.09,0,0,1,.82-.82,2.37,2.37,0,0,1,1.2-.29,2.34,2.34,0,0,1,.95.17,1.49,1.49,0,0,1,.64.47,2,2,0,0,1,.36.68,2.66,2.66,0,0,1,.12.82q0,.36-.45.36H338a1,1,0,0,0,1.15,1.07,1.52,1.52,0,0,0,.59-.12,1.81,1.81,0,0,0,.51-.3.36.36,0,0,1,.36,0,.5.5,0,0,1,.27.34.38.38,0,0,1-.1.4,2.6,2.6,0,0,1-.28.23l-.36.21a1.87,1.87,0,0,1-.52.17,3.1,3.1,0,0,1-.64.06A2.73,2.73,0,0,1,337.74,224.44Zm2.05-2.44a1.47,1.47,0,0,0-.23-.78.76.76,0,0,0-.65-.28.82.82,0,0,0-.67.3,1.29,1.29,0,0,0-.27.76Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M342.49,224.3a1.86,1.86,0,0,1-.36-1.28v-1.87h-.27a.49.49,0,0,1-.36-.12.54.54,0,0,1-.12-.39.41.41,0,0,1,.47-.46h.37l.1-.85c.05-.55.28-.82.67-.82s.54.3.54.89v.78h.54c.31,0,.46.17.46.5a.45.45,0,0,1-.12.35.5.5,0,0,1-.37.12h-.51v1.56a1.56,1.56,0,0,0,.14.78c.08.15.24.21.48.2h.25a.28.28,0,0,1,.22.07.39.39,0,0,1,.13.2.93.93,0,0,1,0,.24.53.53,0,0,1-.08.24.34.34,0,0,1-.18.15,3,3,0,0,1-1,.12A1.4,1.4,0,0,1,342.49,224.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M346.45,224.44a1.89,1.89,0,0,1-.84-.77,2.4,2.4,0,0,1-.31-1.26,2.34,2.34,0,0,1,.28-1.16,2.22,2.22,0,0,1,.82-.82,2.41,2.41,0,0,1,1.21-.29,2.29,2.29,0,0,1,.94.17,1.52,1.52,0,0,1,.65.47,2,2,0,0,1,.35.68,2.66,2.66,0,0,1,.12.82c0,.24-.15.36-.44.36h-2.55a1,1,0,0,0,1.15,1.07,1.53,1.53,0,0,0,.6-.12,1.9,1.9,0,0,0,.5-.3.38.38,0,0,1,.37,0,.52.52,0,0,1,.26.34.36.36,0,0,1-.09.4,2.64,2.64,0,0,1-.29.23l-.36.21a1.91,1.91,0,0,1-.51.17,3.24,3.24,0,0,1-.64.06A2.77,2.77,0,0,1,346.45,224.44ZM348.5,222a1.48,1.48,0,0,0-.22-.78.76.76,0,0,0-.65-.28.81.81,0,0,0-.67.3,1.29,1.29,0,0,0-.27.76Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M350.89,224.13a2.52,2.52,0,0,1-.53-1.71,3.13,3.13,0,0,1,.15-1,1.94,1.94,0,0,1,.43-.7,1.84,1.84,0,0,1,.62-.42,2.13,2.13,0,0,1,.76-.13,1.68,1.68,0,0,1,.86.2,1.15,1.15,0,0,1,.54.55v-1.74a1.26,1.26,0,0,1,.17-.71.67.67,0,0,1,.56-.23.59.59,0,0,1,.51.23,1.34,1.34,0,0,1,.15.71v4.47a1.38,1.38,0,0,1-.17.73.59.59,0,0,1-.53.26.66.66,0,0,1-.51-.19.7.7,0,0,1-.18-.5v0a1.44,1.44,0,0,1-1.45.82A1.74,1.74,0,0,1,350.89,224.13Zm2.83-1.68a1.65,1.65,0,0,0-.27-1,.9.9,0,0,0-.75-.35.85.85,0,0,0-.75.38,1.79,1.79,0,0,0-.26,1,2,2,0,0,0,.06.49,1.65,1.65,0,0,0,.16.44.89.89,0,0,0,.3.34.88.88,0,0,0,.46.12Q353.72,223.86,353.72,222.45Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M356.55,218.78a.62.62,0,0,1,.38-.72,1,1,0,0,1,.9,0,.64.64,0,0,1,.39.72l-.41,3.25a.53.53,0,0,1-.15.32.4.4,0,0,1-.28.11.38.38,0,0,1-.27-.11A.44.44,0,0,1,357,222Zm.32,5.67a.69.69,0,0,1-.22-.53.74.74,0,0,1,.21-.53.69.69,0,0,1,.53-.22.72.72,0,0,1,.52.21.7.7,0,0,1,.22.54.76.76,0,0,1-.21.53.74.74,0,0,1-1.05,0Z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 280.17,
    y1: 262.11,
    x2: 388.54,
    y2: 262.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.17,
    y1: 275.05,
    x2: 388.54,
    y2: 275.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.17,
    y1: 287.99,
    x2: 388.54,
    y2: 287.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.17,
    y1: 300.93,
    x2: 388.54,
    y2: 300.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.41,90.38H271.66a7.39,7.39,0,0,0-7.39,7.39v5.28H346l4.31-4.85H405.8v-.43A7.39,7.39,0,0,0,398.41,90.38Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 264.27,
    y: 90.38,
    width: 141.53,
    height: 237.6,
    rx: 7.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.73,296.5v7.58a.73.73,0,0,0,.73.73h0a.72.72,0,0,0,.73-.73V296.5a.73.73,0,0,0-.73-.73h0A.73.73,0,0,0,412.73,296.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.73,267.44v15.61a.69.69,0,0,0,.73.62h0a.68.68,0,0,0,.73-.62V267.44a.68.68,0,0,0-.73-.62h0A.69.69,0,0,0,412.73,267.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.17,313.79s4-10-9.33-36-.67-68-.67-68",
    style: {
      fill: "none",
      stroke: "#BA68C8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.17,316.46s4.67-10-.67-24.67-3.92-23-3.92-23",
    style: {
      fill: "none",
      stroke: "#BA68C8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.89,271.14s-10.39-12.68-14.39-28-4-22.66-4-22.66",
    style: {
      fill: "none",
      stroke: "#BA68C8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.17,311.12s-4.67-6-6-24a96.1,96.1,0,0,1,3.33-32.66",
    style: {
      fill: "none",
      stroke: "#BA68C8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.04 367.65 122.77 367.65 125.73 309.27 96.07 309.27 99.04 367.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.04 367.65 122.77 367.65 125.73 309.27 96.07 309.27 99.04 367.65",
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.94,277.73c0,.4.6.7.7,1.08s-.22.91-.07,1.27.75.51,1,.85,0,.94.26,1.25.86.3,1.14.58.27.9.58,1.14.91.07,1.25.27.49.8.85.95.9-.17,1.28-.07.68.64,1.07.7.82-.4,1.22-.4.82.45,1.21.4.69-.6,1.07-.7.92.22,1.28.07.51-.76.85-.95.94,0,1.25-.27.3-.86.58-1.14.9-.26,1.14-.58.06-.9.26-1.25.8-.48,1-.85-.17-.89-.06-1.27.64-.68.69-1.08-.39-.81-.39-1.21.44-.83.39-1.21-.59-.7-.69-1.08.22-.91.07-1.27-.76-.51-1-.85,0-.94-.26-1.25-.86-.3-1.14-.58-.26-.9-.58-1.14-.9-.07-1.25-.27-.48-.8-.85-.95-.89.17-1.28.07-.67-.64-1.07-.7-.81.4-1.21.4-.83-.45-1.22-.4-.69.6-1.07.7-.91-.22-1.27-.07-.52.75-.86.95-.93,0-1.25.27-.3.86-.58,1.14-.89.26-1.13.57-.07.91-.27,1.25-.8.49-1,.86.17.89.07,1.27-.65.68-.7,1.07.4.82.4,1.22S104.89,277.35,104.94,277.73ZM92.36,251.45c0-.51-.57-1-.5-1.53s.75-.88.88-1.36-.28-1.15-.09-1.6.95-.65,1.2-1.08,0-1.18.33-1.57,1.09-.38,1.44-.73.33-1.13.73-1.44,1.14-.08,1.57-.33.61-1,1.08-1.2,1.12.22,1.61.09.85-.82,1.35-.88,1,.5,1.53.5,1-.57,1.53-.5.87.75,1.35.88,1.15-.28,1.61-.09.64.95,1.07,1.2,1.18,0,1.58.33.37,1.09.73,1.44,1.13.33,1.43.73.09,1.14.34,1.57,1,.61,1.19,1.08-.21,1.12-.08,1.61.81.85.88,1.35-.51,1-.51,1.53.57,1,.51,1.53-.75.87-.88,1.35.27,1.15.08,1.61-.95.64-1.19,1.07,0,1.18-.34,1.58-1.08.37-1.44.73-.33,1.13-.72,1.43-1.15.09-1.58.34-.61,1-1.07,1.19-1.13-.21-1.61-.08-.85.81-1.35.88-1-.51-1.53-.51-1,.57-1.53.51-.88-.75-1.36-.88-1.15.27-1.6.08-.65-.95-1.08-1.19-1.18,0-1.57-.34-.38-1.08-.73-1.44-1.13-.33-1.44-.72-.08-1.15-.33-1.58-1-.61-1.2-1.07.21-1.13.09-1.61-.82-.85-.88-1.35S92.36,252,92.36,251.45ZM91,296.17c0-.51-.56-1-.5-1.53s.75-.87.88-1.35-.28-1.15-.09-1.61,1-.65,1.2-1.08,0-1.18.33-1.57,1.09-.38,1.44-.73.33-1.13.73-1.44,1.14-.08,1.57-.33.62-1,1.08-1.2,1.12.22,1.61.09.85-.81,1.35-.88,1,.5,1.53.5,1-.56,1.53-.5.87.75,1.35.88,1.15-.28,1.61-.09.64.95,1.07,1.2,1.18,0,1.58.34.37,1.08.73,1.43,1.13.34,1.43.73.09,1.14.34,1.58,1,.61,1.2,1.07-.22,1.12-.09,1.61.81.85.88,1.35-.5,1-.5,1.53.56,1,.5,1.53-.75.87-.88,1.35.28,1.15.09,1.61-1,.65-1.2,1.08,0,1.18-.34,1.57-1.08.38-1.43.73-.34,1.13-.73,1.44-1.15.08-1.58.33-.61,1-1.07,1.2-1.13-.22-1.61-.09-.85.81-1.35.88-1-.5-1.53-.5-1,.56-1.53.5-.88-.75-1.35-.88-1.15.28-1.61.09-.65-.95-1.08-1.2-1.18,0-1.57-.34-.38-1.08-.73-1.43-1.13-.33-1.44-.73-.08-1.14-.33-1.58-1-.61-1.2-1.07.22-1.12.09-1.61-.82-.85-.88-1.35S91,296.68,91,296.17Zm23,6.35c0-.33-.58-.7-.54-1s.7-.54.78-.86-.37-.82-.25-1.12.81-.34,1-.62-.15-.9,0-1.16.87-.11,1.1-.34.09-.91.35-1.11.87.12,1.15-.05.32-.84.62-1,.81.33,1.13.25.52-.74.85-.78.69.53,1,.53.7-.57,1-.53.54.69.86.78.82-.38,1.13-.25.33.81.62,1,.89-.14,1.15.06.11.86.35,1.1.9.08,1.1.34-.12.87.05,1.16.85.31,1,.62-.33.81-.25,1.13.74.52.78.85-.53.69-.53,1,.57.71.53,1-.69.54-.78.85.38.83.25,1.13-.81.34-1,.62.15.89-.05,1.15-.87.12-1.11.35-.08.9-.34,1.1-.87-.11-1.16.05-.31.85-.62,1-.8-.34-1.12-.25-.53.73-.86.78-.69-.54-1-.54-.7.58-1,.54-.53-.7-.85-.78-.83.37-1.13.25-.33-.81-.62-1-.89.15-1.15-.05-.12-.87-.35-1.1-.9-.09-1.1-.35.11-.87,0-1.15-.85-.32-1-.62.34-.81.25-1.13-.73-.52-.78-.85S114,302.86,114,302.52ZM89.69,211.05c0-.51-.57-1.05-.5-1.54s.75-.87.87-1.35-.27-1.15-.08-1.6,1-.65,1.2-1.08,0-1.18.33-1.57,1.09-.38,1.44-.73.33-1.13.73-1.44,1.14-.08,1.57-.33.61-1,1.08-1.2,1.12.21,1.6.08.85-.81,1.35-.87,1,.5,1.54.5,1-.57,1.53-.5.87.75,1.35.87,1.15-.27,1.61-.08.64.95,1.07,1.2,1.18,0,1.58.33.37,1.09.72,1.44,1.14.33,1.44.73.08,1.14.33,1.57,1,.61,1.2,1.08-.21,1.12-.08,1.6.81.86.87,1.36-.5,1-.5,1.53.57,1,.5,1.53-.75.87-.87,1.35.27,1.15.08,1.61-1,.64-1.2,1.07,0,1.18-.33,1.58-1.08.37-1.44.73-.33,1.13-.73,1.43-1.14.08-1.57.34-.61,1-1.08,1.19-1.12-.21-1.6-.08-.85.81-1.35.88-1-.51-1.53-.51-1,.57-1.54.5-.87-.75-1.35-.87-1.15.27-1.6.08-.65-.95-1.08-1.2-1.18,0-1.58-.33-.37-1.08-.72-1.44-1.14-.33-1.44-.72-.08-1.15-.33-1.58-1-.61-1.2-1.07.21-1.13.08-1.61-.81-.85-.87-1.35S89.69,211.55,89.69,211.05ZM69.32,231.41c0-.5-.56-1-.5-1.53s.75-.87.88-1.35-.28-1.15-.09-1.61,1-.64,1.2-1.07,0-1.18.33-1.58,1.09-.37,1.44-.73.33-1.13.73-1.43,1.14-.09,1.57-.34.62-1,1.08-1.19,1.12.21,1.61.08.85-.81,1.35-.88,1,.51,1.53.51,1-.57,1.53-.51.87.75,1.35.88,1.15-.27,1.61-.08.64.95,1.07,1.19,1.18,0,1.58.34.38,1.08.73,1.44,1.13.33,1.43.72.09,1.15.34,1.58,1,.61,1.2,1.07-.22,1.13-.09,1.61.81.85.88,1.35-.5,1-.5,1.53.56,1.05.5,1.53-.75.88-.88,1.36.28,1.15.09,1.6-1,.65-1.2,1.08,0,1.18-.34,1.57-1.08.38-1.43.73-.34,1.13-.73,1.44-1.14.08-1.58.33-.61,1-1.07,1.2-1.13-.22-1.61-.09-.85.82-1.35.88-1-.5-1.53-.5-1,.57-1.53.5-.88-.75-1.35-.88-1.15.28-1.61.09-.65-.95-1.08-1.2-1.18,0-1.57-.33-.38-1.09-.73-1.44-1.13-.33-1.44-.73-.08-1.14-.33-1.57-1-.61-1.2-1.08.22-1.12.09-1.61-.82-.85-.88-1.35S69.32,231.92,69.32,231.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.94,277.73c0,.4.6.7.7,1.08s-.22.91-.07,1.27.75.51,1,.85,0,.94.26,1.25.86.3,1.14.58.27.9.58,1.14.91.07,1.25.27.49.8.85.95.9-.17,1.28-.07.68.64,1.07.7.82-.4,1.22-.4.82.45,1.21.4.69-.6,1.07-.7.92.22,1.28.07.51-.76.85-.95.94,0,1.25-.27.3-.86.58-1.14.9-.26,1.14-.58.06-.9.26-1.25.8-.48,1-.85-.17-.89-.06-1.27.64-.68.69-1.08-.39-.81-.39-1.21.44-.83.39-1.21-.59-.7-.69-1.08.22-.91.07-1.27-.76-.51-1-.85,0-.94-.26-1.25-.86-.3-1.14-.58-.26-.9-.58-1.14-.9-.07-1.25-.27-.48-.8-.85-.95-.89.17-1.28.07-.67-.64-1.07-.7-.81.4-1.21.4-.83-.45-1.22-.4-.69.6-1.07.7-.91-.22-1.27-.07-.52.75-.86.95-.93,0-1.25.27-.3.86-.58,1.14-.89.26-1.13.57-.07.91-.27,1.25-.8.49-1,.86.17.89.07,1.27-.65.68-.7,1.07.4.82.4,1.22S104.89,277.35,104.94,277.73ZM92.36,251.45c0-.51-.57-1-.5-1.53s.75-.88.88-1.36-.28-1.15-.09-1.6.95-.65,1.2-1.08,0-1.18.33-1.57,1.09-.38,1.44-.73.33-1.13.73-1.44,1.14-.08,1.57-.33.61-1,1.08-1.2,1.12.22,1.61.09.85-.82,1.35-.88,1,.5,1.53.5,1-.57,1.53-.5.87.75,1.35.88,1.15-.28,1.61-.09.64.95,1.07,1.2,1.18,0,1.58.33.37,1.09.73,1.44,1.13.33,1.43.73.09,1.14.34,1.57,1,.61,1.19,1.08-.21,1.12-.08,1.61.81.85.88,1.35-.51,1-.51,1.53.57,1,.51,1.53-.75.87-.88,1.35.27,1.15.08,1.61-.95.64-1.19,1.07,0,1.18-.34,1.58-1.08.37-1.44.73-.33,1.13-.72,1.43-1.15.09-1.58.34-.61,1-1.07,1.19-1.13-.21-1.61-.08-.85.81-1.35.88-1-.51-1.53-.51-1,.57-1.53.51-.88-.75-1.36-.88-1.15.27-1.6.08-.65-.95-1.08-1.19-1.18,0-1.57-.34-.38-1.08-.73-1.44-1.13-.33-1.44-.72-.08-1.15-.33-1.58-1-.61-1.2-1.07.21-1.13.09-1.61-.82-.85-.88-1.35S92.36,252,92.36,251.45ZM91,296.17c0-.51-.56-1-.5-1.53s.75-.87.88-1.35-.28-1.15-.09-1.61,1-.65,1.2-1.08,0-1.18.33-1.57,1.09-.38,1.44-.73.33-1.13.73-1.44,1.14-.08,1.57-.33.62-1,1.08-1.2,1.12.22,1.61.09.85-.81,1.35-.88,1,.5,1.53.5,1-.56,1.53-.5.87.75,1.35.88,1.15-.28,1.61-.09.64.95,1.07,1.2,1.18,0,1.58.34.37,1.08.73,1.43,1.13.34,1.43.73.09,1.14.34,1.58,1,.61,1.2,1.07-.22,1.12-.09,1.61.81.85.88,1.35-.5,1-.5,1.53.56,1,.5,1.53-.75.87-.88,1.35.28,1.15.09,1.61-1,.65-1.2,1.08,0,1.18-.34,1.57-1.08.38-1.43.73-.34,1.13-.73,1.44-1.15.08-1.58.33-.61,1-1.07,1.2-1.13-.22-1.61-.09-.85.81-1.35.88-1-.5-1.53-.5-1,.56-1.53.5-.88-.75-1.35-.88-1.15.28-1.61.09-.65-.95-1.08-1.2-1.18,0-1.57-.34-.38-1.08-.73-1.43-1.13-.33-1.44-.73-.08-1.14-.33-1.58-1-.61-1.2-1.07.22-1.12.09-1.61-.82-.85-.88-1.35S91,296.68,91,296.17Zm23,6.35c0-.33-.58-.7-.54-1s.7-.54.78-.86-.37-.82-.25-1.12.81-.34,1-.62-.15-.9,0-1.16.87-.11,1.1-.34.09-.91.35-1.11.87.12,1.15-.05.32-.84.62-1,.81.33,1.13.25.52-.74.85-.78.69.53,1,.53.7-.57,1-.53.54.69.86.78.82-.38,1.13-.25.33.81.62,1,.89-.14,1.15.06.11.86.35,1.1.9.08,1.1.34-.12.87.05,1.16.85.31,1,.62-.33.81-.25,1.13.74.52.78.85-.53.69-.53,1,.57.71.53,1-.69.54-.78.85.38.83.25,1.13-.81.34-1,.62.15.89-.05,1.15-.87.12-1.11.35-.08.9-.34,1.1-.87-.11-1.16.05-.31.85-.62,1-.8-.34-1.12-.25-.53.73-.86.78-.69-.54-1-.54-.7.58-1,.54-.53-.7-.85-.78-.83.37-1.13.25-.33-.81-.62-1-.89.15-1.15-.05-.12-.87-.35-1.1-.9-.09-1.1-.35.11-.87,0-1.15-.85-.32-1-.62.34-.81.25-1.13-.73-.52-.78-.85S114,302.86,114,302.52ZM89.69,211.05c0-.51-.57-1.05-.5-1.54s.75-.87.87-1.35-.27-1.15-.08-1.6,1-.65,1.2-1.08,0-1.18.33-1.57,1.09-.38,1.44-.73.33-1.13.73-1.44,1.14-.08,1.57-.33.61-1,1.08-1.2,1.12.21,1.6.08.85-.81,1.35-.87,1,.5,1.54.5,1-.57,1.53-.5.87.75,1.35.87,1.15-.27,1.61-.08.64.95,1.07,1.2,1.18,0,1.58.33.37,1.09.72,1.44,1.14.33,1.44.73.08,1.14.33,1.57,1,.61,1.2,1.08-.21,1.12-.08,1.6.81.86.87,1.36-.5,1-.5,1.53.57,1,.5,1.53-.75.87-.87,1.35.27,1.15.08,1.61-1,.64-1.2,1.07,0,1.18-.33,1.58-1.08.37-1.44.73-.33,1.13-.73,1.43-1.14.08-1.57.34-.61,1-1.08,1.19-1.12-.21-1.6-.08-.85.81-1.35.88-1-.51-1.53-.51-1,.57-1.54.5-.87-.75-1.35-.87-1.15.27-1.6.08-.65-.95-1.08-1.2-1.18,0-1.58-.33-.37-1.08-.72-1.44-1.14-.33-1.44-.72-.08-1.15-.33-1.58-1-.61-1.2-1.07.21-1.13.08-1.61-.81-.85-.87-1.35S89.69,211.55,89.69,211.05ZM69.32,231.41c0-.5-.56-1-.5-1.53s.75-.87.88-1.35-.28-1.15-.09-1.61,1-.64,1.2-1.07,0-1.18.33-1.58,1.09-.37,1.44-.73.33-1.13.73-1.43,1.14-.09,1.57-.34.62-1,1.08-1.19,1.12.21,1.61.08.85-.81,1.35-.88,1,.51,1.53.51,1-.57,1.53-.51.87.75,1.35.88,1.15-.27,1.61-.08.64.95,1.07,1.19,1.18,0,1.58.34.38,1.08.73,1.44,1.13.33,1.43.72.09,1.15.34,1.58,1,.61,1.2,1.07-.22,1.13-.09,1.61.81.85.88,1.35-.5,1-.5,1.53.56,1.05.5,1.53-.75.88-.88,1.36.28,1.15.09,1.6-1,.65-1.2,1.08,0,1.18-.34,1.57-1.08.38-1.43.73-.34,1.13-.73,1.44-1.14.08-1.58.33-.61,1-1.07,1.2-1.13-.22-1.61-.09-.85.82-1.35.88-1-.5-1.53-.5-1,.57-1.53.5-.88-.75-1.35-.88-1.15.28-1.61.09-.65-.95-1.08-1.2-1.18,0-1.57-.33-.38-1.09-.73-1.44-1.13-.33-1.44-.73-.08-1.14-.33-1.57-1-.61-1.2-1.08.22-1.12.09-1.61-.82-.85-.88-1.35S69.32,231.92,69.32,231.41Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.77,364.79l-31.69-1.18a2.32,2.32,0,0,0-2.45,2.44,1,1,0,0,0,1.14,1,7.27,7.27,0,0,0,3.5-.75l25,7.5S190.52,375.79,186.77,364.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,337.79v29.5l-43.25,22.5s-3.25,4.5.5,5a4.06,4.06,0,0,0,5-3.75s47-14.25,48-14.25,45.5,12,45.5,12-1.75,2,1.5,3,3.5-3,2.5-4.5-48.5-22-48.5-22V338.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,273.41a19.6,19.6,0,0,1-6.15-2.07,64.61,64.61,0,0,1-10.43-7.3C229,257,221,242.54,214,234.79s-20.5-12-39.75-10-29,9.75-32.75,19.75-4.25,19.5-8.25,28.25-12.5,12-11,21,10.25,23.75,28.25,35.25,39.25,15.75,63,13.25,33.5-12.75,41.75-24.75,9.25-26.25,8-33.75C262.21,277.41,257.89,274.11,253.85,273.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,237.44A36.05,36.05,0,0,0,152,244.7c-8.78,8.54-5,20.33-7.81,31A55.81,55.81,0,0,1,140,286.43s3.44,21.44,17.22,29.86,36,14.16,54.73,10.71,28.7-13.39,33.29-21.81S247.88,283,236,275s-19.52-24.11-30.24-31.76C193,234.08,176.39,231.39,162.7,237.44Z",
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,274.8a19.66,19.66,0,0,0-2.77.24s-5.5-.25-9,8.5-1,18.5-5.5,25.5-8,7.75-36.75,8-38.75,5.25-50.25-9.75-7-22.5-16.5-26c-4.69-1.73-7.73-1.14-10,.59-3,3.49-5.39,6.76-4.53,11.91,1.5,9,10.25,23.75,28.25,35.25s39.25,15.75,63,13.25,33.5-12.75,41.75-24.75,9.25-26.25,8-33.75A12.53,12.53,0,0,0,257.54,274.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.54,274.8a19.66,19.66,0,0,0-2.77.24s-5.5-.25-9,8.5-1,18.5-5.5,25.5-8,7.75-36.75,8-38.75,5.25-50.25-9.75-7-22.5-16.5-26c-4.69-1.73-7.73-1.14-10,.59-3,3.49-5.39,6.76-4.53,11.91,1.5,9,10.25,23.75,28.25,35.25s39.25,15.75,63,13.25,33.5-12.75,41.75-24.75,9.25-26.25,8-33.75A12.53,12.53,0,0,0,257.54,274.8Z",
    style: {
      opacity: 0.17
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,274.8a19.66,19.66,0,0,0-2.77.24s-5.5-.25-9,8.5-1,18.5-5.5,25.5-8,7.75-36.75,8-38.75,5.25-50.25-9.75-7-22.5-16.5-26c-4.69-1.73-7.73-1.14-10,.59-3,3.49-5.39,6.76-4.53,11.91,1.5,9,10.25,23.75,28.25,35.25s39.25,15.75,63,13.25,33.5-12.75,41.75-24.75,9.25-26.25,8-33.75A12.53,12.53,0,0,0,257.54,274.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,265s-11.5,12.5-14.75,24.5,2,25.25,11.25,28.5,22.75-1.25,29-3.75,15.5,2,25.75,2.25S236,296.29,233.52,284s-13.5-23.25-24.25-25S178.52,258.29,173,265Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,188s9.9,4.86,14.76,6.16,16.06,1.31,16.62,5.42-1.68,26.52-3,33.8-1.49,18.12-.75,20.92,3,7.28.38,11.77-4.11,10.27-10.09,9.33-7.47-5.23-7.47-5.23l-36.41,4.49s-2.81-14.76-6-27.83-9.71-31.75-9.15-40.71,12.14-14.57,20.17-17.18S211.33,188,211.33,188Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.38,212.36c-.94,3-5.25,13.87-5.25,13.87s1.71-10,2.86-18,1.43-7.14-2.29-7.14-10.29-3.15-12.57-4.29-1.15,1.43-3.43-.29-5.72-7.14-5.72-7.14c-6.29-1.43-31.43,1.72-33.72,8.86-1.53,4.77-.76,29.4,1,48.15l.12.47c2.16,8.9,4.15,18.57,5.2,23.84a14.46,14.46,0,0,0,3.59,3.64l33.33-4.1c4.14-4.46,7.36-10.7,8.46-12,1.29-1.49,5.43-4.28,5.72-6.86s-1.14-20.29.29-26.57C237.08,220,238,214.38,238.38,212.36Zm-8.11,29c-3.71,4.86-13.72,1.43-19.43-.57s-10.86,4-17.15,2.57,1.43-10.57,9.43-10.86,6-.57,13.15-9.14,11.43-.86,14.29,5.71A14.89,14.89,0,0,1,230.27,241.37Z",
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.79,199.78s-.19,8.77-1.68,13.44S233,226.11,233,230.78s.93,11.39-.56,15.69-8.22,11-8.22,17.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,188s9.9,4.86,14.76,6.16,16.06,1.31,16.62,5.42-1.68,26.52-3,33.8-1.49,18.12-.75,20.92,3,7.28.38,11.77-4.11,10.27-10.09,9.33-7.47-5.23-7.47-5.23l-36.41,4.49s-2.81-14.76-6-27.83-9.71-31.75-9.15-40.71,12.14-14.57,20.17-17.18S211.33,188,211.33,188Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.39,234.14s1.12,13.26,2.24,19.24a81.68,81.68,0,0,1,1.31,10.45s4.48-.93,5.41,2.62a11.21,11.21,0,0,1-3.92,11.39c-3.74,2.8-8.78,4.67-12.51,3.55s-5-10.46-5-16.25,0-13.26-1.68-17.55S171.37,229.28,182.39,234.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.66,269.35c-2.73.6-8.78,1.51-9.39-.91s3.44-5.17,3.44-5.17l3.22.32v-2.12s-1.51-12.41-3-17-9.69,0-12.72,3.07c1.69,4.29,1.69,11.76,1.69,17.55s1.3,15.13,5,16.25,8.77-.75,12.51-3.55a10.79,10.79,0,0,0,3.89-6.06A4.9,4.9,0,0,0,186.66,269.35Z",
    style: {
      opacity: 0.17
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.39,234.14s1.12,13.26,2.24,19.24a81.68,81.68,0,0,1,1.31,10.45s4.48-.93,5.41,2.62a11.21,11.21,0,0,1-3.92,11.39c-3.74,2.8-8.78,4.67-12.51,3.55s-5-10.46-5-16.25,0-13.26-1.68-17.55S171.37,229.28,182.39,234.14Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.87,264.39a44.92,44.92,0,0,1-6.16-1.12c-3.93-.93-6.35.94-7.1,6.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.85,196s-.56,8.22-1.87,15.5a35.76,35.76,0,0,1-4.3,12s0-16.62-2.61-24.65-1.68-13.82,2.24-12S192.85,196,192.85,196Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79,196.6a55,55,0,0,0,0,10.27,52.09,52.09,0,0,0,1.5,8l5.22-5.41L195.27,216,207,223.49l7.28-11.2L210,207.43s6.72,3.74,7.28,3.55-.93-9.34-4.11-14.94-12.14-9-15.13-8S190.23,193.8,190.79,196.6Z",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,202.77s6,17.74,8.6,17.18,3.92-19.61,3.92-19.61A16.06,16.06,0,0,1,197,202.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,202.77s6,17.74,8.6,17.18,3.92-19.61,3.92-19.61A16.06,16.06,0,0,1,197,202.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,202.77s6,17.74,8.6,17.18,3.92-19.61,3.92-19.61A16.06,16.06,0,0,1,197,202.77Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197,202.77s6,17.74,8.6,17.18,3.92-19.61,3.92-19.61A16.06,16.06,0,0,1,197,202.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,185.77s6.66,12,11.77,16.06c4.76,3.79,12.14,5.42,15.68,1.12s4.49-14,4.3-20.17-4.67-10.27-9.71-15.31-12.7-11.58-17.74-8.22S180,181.85,181.64,185.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.09,203c.12-.14.23-.3.34-.45a18.76,18.76,0,0,1-6,1.37c-6.68.29-11-5.81-11-5.81s-.58-.87-4.06-7.26S186,166.69,186,166.69s2.61,3.49,9.87,5.23a78.55,78.55,0,0,0,12.78,2l-.27-1.67c-1.41-1.57-3-3.14-4.68-4.81-5-5-12.7-11.58-17.74-8.22s-6,22.6-4.3,26.52c0,0,6.66,12,11.77,16.06C198.17,205.62,205.55,207.25,209.09,203Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,203c.12-.14.23-.3.34-.45a18.76,18.76,0,0,1-6,1.37c-6.68.29-11-5.81-11-5.81s-.58-.87-4.06-7.26S186,166.69,186,166.69s2.61,3.49,9.87,5.23a78.55,78.55,0,0,0,12.78,2l-.27-1.67c-1.41-1.57-3-3.14-4.68-4.81-5-5-12.7-11.58-17.74-8.22s-6,22.6-4.3,26.52c0,0,6.66,12,11.77,16.06C198.17,205.62,205.55,207.25,209.09,203Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,184.46s4.3,1.12,6-1.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.49,181.1s4.11,1.12,5.79-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94,180.73a8.78,8.78,0,0,1,7.84-2.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.81,177.55s1.68-3.17,7.1-2.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2,190.63s2.8,1.12,3.92-1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,195.29s4.85.57,6.91-2.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,185.77s6.66,12,11.77,16.06c4.76,3.79,12.14,5.42,15.68,1.12s4.49-14,4.3-20.17-4.67-10.27-9.71-15.31-12.7-11.58-17.74-8.22S180,181.85,181.64,185.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,271.12a34.11,34.11,0,0,1,.37-6.73c.56-3,1.68-4.29,1.68-7.65s.19-4.67,2.43-4.67,6.53.19,6.72,1.68.37,2.43-.56,2.24-4.85-.37-4.85-.37l-.56,1.49a54.34,54.34,0,0,1,5.41,2.06c.93.56,1.12,4.66,1.12,6.91a4.49,4.49,0,0,1-3,4.66c-2.05.75-3.92-1.86-3.92-1.86s.38,2.8-1.68,3.73S185.94,272.24,186.5,271.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,247.1l-3.3,28.59a2.65,2.65,0,0,0,2.75,2.95l25.23-1.09a2.66,2.66,0,0,0,2.44-1.93l7.85-28a2.65,2.65,0,0,0-2.59-3.37l-29.79.47A2.64,2.64,0,0,0,195,247.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,248.25l-3,26.29a2.44,2.44,0,0,0,2.53,2.72l23.2-1a2.44,2.44,0,0,0,2.24-1.78l7.23-25.72a2.44,2.44,0,0,0-2.39-3.1l-27.39.43A2.44,2.44,0,0,0,196.28,248.25Z",
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.53,
    y1: 254.75,
    x2: 193.25,
    y2: 274.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,246.06l-1.6,0a2.44,2.44,0,0,0-2.39,2.16l-.35,3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,264.21s-3-4.48-5.23-4.48-12.32,5.78-14.94,7.47.19,2.42.19,2.42a2,2,0,0,0,.56,2.24,3.23,3.23,0,0,0,2.05,1.13,3.43,3.43,0,0,0,1.5,1.3,9.85,9.85,0,0,0,3.36.56s.93.75,4.11.75,6.16-.19,8-2.43S235.24,268.69,233.93,264.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,269.62s12-2.05,14.19-4.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,273s9.71-1.5,12.7-3.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,274.85s6-.37,8.59-1.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,283.79s38.75-5.25,54.5-3.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,337.54s10.75-4.5,28,0c0,0-1.75,2.75-12.75,5S219.27,337.54,219.27,337.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,280.28a12.43,12.43,0,0,1-2.1,1c-1.79.65-5.52,2.67-7,8.47-2,7.75,8,28.75,9.25,38a105.21,105.21,0,0,0,2.25,12.75s3.75,1,10,2,8.5-2.25,8.5-2.25,2.75-23-1.25-37-4.75-20.5-10-22.5C226.09,279.39,221.79,279.31,220.13,280.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.71,343s1.16-22.66-5.23-41.53-11.91-18.3-16.56-14.53-4.93,12.2-2.32,20.63,7,17.71,7.55,25.55-.29,13.07,2.91,13.36S239.42,348.8,239.71,343Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.71,343s1.16-22.66-5.23-41.53-11.91-18.3-16.56-14.53-4.93,12.2-2.32,20.63,7,17.71,7.55,25.55-.29,13.07,2.91,13.36S239.42,348.8,239.71,343Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,280.28a12.43,12.43,0,0,1-2.1,1c-1.79.65-5.52,2.67-7,8.47-2,7.75,8,28.75,9.25,38a105.21,105.21,0,0,0,2.25,12.75s3.75,1,10,2,8.5-2.25,8.5-2.25,2.75-23-1.25-37-4.75-20.5-10-22.5C226.09,279.39,221.79,279.31,220.13,280.28Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,337.54s17.25,4.25,28,0c0,0-6.25,29-10.75,41.75s-4.25,18.75-5,25.75-5,19.25-10.5,21.25-6-7.5-2.25-16.75,5.25-20.5,3.75-34S219.27,337.54,219.27,337.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.74,348.8a56.79,56.79,0,0,0,2.48-10.31c-6.84,1.65-15.17.79-20.27,0,.56,7.94,1.94,29.86,1.23,44.62-.8,16.95-4.85,23.68-8,31.28a20.44,20.44,0,0,0-.54,9.15c1.58,1.37,4.61.76,7.65-1.8,5.52-4.65,6.68-21.21,7.26-30.21S239.12,356.35,241.74,348.8Z",
    style: {
      opacity: 0.17
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,337.54s17.25,4.25,28,0c0,0-6.25,29-10.75,41.75s-4.25,18.75-5,25.75-5,19.25-10.5,21.25-6-7.5-2.25-16.75,5.25-20.5,3.75-34S219.27,337.54,219.27,337.54Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.02 374.04 236.77 397.54 238.77 396.54 237.02 374.04",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.52 371.54 239.52 394.29 241.27 393.04 237.52 371.54",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,339s-8.25-4.25-26.5-1.25A18.68,18.68,0,0,0,196.27,345C203.52,346.79,212,339,212,339Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,282s-9-3.75-15.5,2.25-4.5,19-4,21.5,1,5.25,1,5.25l1.25,31.75,17.5.25s3.25-25.25,5.75-36.25S215.52,287.29,207,282Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.43,289c-10.16-3.49-12.48,5.81-13.36,13.94s-.87,37.46-.58,39.21a1.85,1.85,0,0,0,.4.7l15.38.22s3.25-25.25,5.75-36.25c.17-.77.33-1.53.48-2.27C213.56,299.79,212.6,291.42,205.43,289Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,289c-10.16-3.49-12.48,5.81-13.36,13.94s-.87,37.46-.58,39.21a1.85,1.85,0,0,0,.4.7l15.38.22s3.25-25.25,5.75-36.25c.17-.77.33-1.53.48-2.27C213.56,299.79,212.6,291.42,205.43,289Z",
    style: {
      fill: "#fff",
      opacity: 0.53
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207,282s-9-3.75-15.5,2.25-4.5,19-4,21.5,1,5.25,1,5.25l1.25,31.75,17.5.25s3.25-25.25,5.75-36.25S215.52,287.29,207,282Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,337.79s3.25,24,6.5,35,6.5,24,6.5,37,10.5,18.5,13.25,16,.5-15-1.75-21.5-5.25-22.75-4.25-31.25S212,339,212,339,194.52,340,185.52,337.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.11,367.09c1.16-21.49,6.68-27.88,6.68-27.88l-.49-.06a139.33,139.33,0,0,1-18.56-.47c.39,5.57,1.82,23.25,5,38.11,3.86,17.9,3.27,28.06,6.18,36.19s9,14.24,9,7.55S202,388.59,203.11,367.09Z",
    style: {
      opacity: 0.17
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,337.79s3.25,24,6.5,35,6.5,24,6.5,37,10.5,18.5,13.25,16,.5-15-1.75-21.5-5.25-22.75-4.25-31.25S212,339,212,339,194.52,340,185.52,337.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.27 368.29 190.27 393.04 191.52 393.54 191.27 368.29",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.02 369.29 193.02 394.04 195.02 392.29 192.02 369.29",
    style: {
      fill: "#BA68C8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.06,162.05s-5.05,16.62-1.5,30.82,1.87,30.06,1.5,38.84-3.55,16.06-10.65,21.67-16.62,4.66-23.72-.19-9.33-18.68-5.41-28.39,13.63-26.7,16.43-35.48,1.12-13.26,1.87-21.48,5.6-23.16,15.69-26.52,21.85-3.17,29.88,7.66,8.78,27.45,9.52,32.87,3,7.28,7.47,8.22,3.74,4.1.38,4.48-12.1-1.93-14.52-5.11-.42-8.15-4.53-13S191.17,169.71,187.06,162.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24,226.79c.14,7.07-.35,13.12-2,16.5-4.86,10.09-12,10-20.5,8.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.06,162.05s-9.29,10.24-7.79,23.74c.83,7.49,2.85,21.28,3.65,33.79",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,230.39c-2.52,2.27-4.08.9-4.08.9",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.27,185.29s2,22.5-3.5,36a39.93,39.93,0,0,1-2.92,5.93",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.94,159.15a19.22,19.22,0,0,0-12.67-5.86c-13-1-13.33,6-13.33,6s-5.17-11.46,13.33-12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.27,165.79a17.9,17.9,0,0,0-1.59-3.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.f2c9de244214673c2d03360b009323c5.svg";
export { ForwardRef as ReactComponent };